import { useState, useEffect } from 'react';
import { API, Auth, Storage } from 'aws-amplify';

import {
    Heading,
    Expander,
    Button,
    Link,
    Text,
    View,
    Collection,
    Rating,
    Loader,
    ExpanderItem,
    TextField,
    Image,
    Flex,
    Badge,
    Tabs,
    TabItem
} from '@aws-amplify/ui-react';

import { useNavigate } from "react-router-dom";
import { AddProfile } from "./AddProfile";
import TaskDonutCharts from './TaskDonutCharts';
import GrowChart from './GrowChart';

const trimString = (str, numChar) => str.length > numChar ? str.substring(0, numChar) + '...' : str;

export function Tasks({ updateProfiles, aProfile, updateAProfile, profiles, balance, updateBalance }) {
    const navigate = useNavigate();

    const [isMobile] = useState(/iphone|ipad/i.test(navigator.userAgent));
    const [isLoading, setLoading] = useState(true);
    const [tasks, setTasks] = useState([]);
    const [doneButtons, setDoneButtons] = useState([]);
    const [repostUrlHasError, setRepostUrlHasError] = useState(false);
    const [postUrlHasError, setPostUrlHasError] = useState(false);
    const [engagePercent, setEngagePercent] = useState(0);

    /*aProfile.followersDynamic=`[
        {
            "date": "2025-04-07",
            "followers": 1434
        },
        {
            "date": "2025-04-08",
            "followers": 1436
        }
    ]`;*/

    // Track which tab is active (0 => Engage, 1 => Post, 2 => Grow)
    const [currentTab, setCurrentTab] = useState(0);

    // Helper for mapping tab index -> string
    const tabMapping = ["engage", "post", "grow"];

    async function getTasks(forProfile) {
        if (!forProfile.profileUrl) return;
        setLoading(true);

        const userUpdate = await Auth.currentAuthenticatedUser();
        const requestTasks = {
            headers: {
                Authorization: `${userUpdate.signInUserSession.idToken.jwtToken}`
            }
        };

        let data = [];

        try {
            const dataLoc = await API.get(
                "gcAPI",
                `/get-tasks/${userUpdate.username + '_' + encodeURIComponent(forProfile.profileUrl)}/new`,
                requestTasks
            );
            if (dataLoc.data) {
                data = dataLoc.data;
            };
            if (dataLoc.engagePercent) {
                console.log('engagePercent', dataLoc.engagePercent);
                setEngagePercent(dataLoc.engagePercent);
            };

        } catch (e) {
            console.log('retrying after 30 sec timeout...');
            try {
                const dataLoc = await API.get(
                    "gcAPI",
                    `/get-tasks/${userUpdate.username + '_' + encodeURIComponent(forProfile.profileUrl)}/new`,
                    requestTasks
                );
                if (dataLoc.data) {
                    data = dataLoc.data;
                };
                if (dataLoc.engagePercent) {
                    console.log('engagePercent', dataLoc.engagePercent);
                    setEngagePercent(dataLoc.engagePercent);
                };
            } catch (e) {
                console.log('something went wrong', e.message);
            }
        }
        console.log('tasks data:', data);

        // Preload avatarUrl from Storage if needed
        const tasksWithAvatars = await Promise.all(data.map(async (el) => {
            el.oldAvatarUrl = el.avatarUrl;
            if (el.SK.indexOf("TASK CONNECT") > -1) {
                // Random default avatar
                /*
                var allAvas = [
                    "0be0ea02e75ea8424ddf",
                    "76ac73b6f9eecc945d8a",
                    "Bogota",
                    "CosmoBlue",
                    "ElephantCat",
                    "Etno",
                    "jiri-terc-66160273",
                    "jonaspetersenfromsisaro",
                    "jvelascoastete",
                    "ken-ratama-16a52718a",
                    "PechorinBloom",
                    "Spanglinga"
                ];
                let newSK = allAvas[Math.floor(Math.random() * allAvas.length)];
                el.avatarUrl = 'avatars/' + newSK + '.png';*/
            } else if (el.SK.indexOf("TASK POST") > -1) {
                // do nothing, handled on front-end
            } else if (el.avatarUrl.indexOf("media.licdn.com") > -1) {
                // do nothing, handled on front-end
            } else {
                try {
                    el.avatarUrl = await Storage.get(el.avatarUrl, {
                        level: "protected",
                        identityId: el.authorUser
                    });
                } catch (error) {
                    // default fallback
                    el.avatarUrl = 'https://www.gravatar.com/avatar/00000000000000000000000000000000?d=mp&f=y';
                }
            }
            return el;
        }));

        setTasks(tasksWithAvatars);
        // Create a parallel array of "done" flags (false initially)
        setDoneButtons(new Array(data.length).fill(false));

        setLoading(false);
    }

    async function setTaskStage(taskItem, stage, elementId) {
        var repostUrl = "";
        var newPostUrl = "";
        if (taskItem.requestType.indexOf("REPOST") > -1) {
            repostUrl = document.getElementById("repostUrl-" + elementId)?.value || "";
        };

        if (taskItem.SK.indexOf("POST") > -1) {
            newPostUrl = document.getElementById("postUrl-" + elementId)?.value || "";
        };

        const user = await Auth.currentAuthenticatedUser();
        const requestSetTaskStage = {
            headers: {
                Authorization: `${user.signInUserSession.idToken.jwtToken}`
            },
            body: {
                taskItem: taskItem,
                newStage: stage
            }
        };

        if (taskItem.requestType.indexOf("REPOST") > -1) {
            if (repostUrl.length > 0) {
                requestSetTaskStage.body.repostUrl = repostUrl;
            } else if (stage !== "rejected") {
                setRepostUrlHasError(true);
                return;
            }
        };

        if (taskItem.SK.indexOf("POST") > -1) {
            if (newPostUrl.length > 0) {
                requestSetTaskStage.body.newPostUrl = newPostUrl;
            } else if (stage !== "rejected") {
                setPostUrlHasError(true);
                return;
            }
        };

        // remove the entire Expander containing element
        const elemToRemove = document.getElementById(elementId);
        if (elemToRemove?.parentNode) {
            elemToRemove.parentNode.remove();
        }
        setRepostUrlHasError(false);
        setPostUrlHasError(false);

        try {
            const data = await API.post("gcAPI", `/update-task`, requestSetTaskStage);
            if (data.res !== "success") {
                console.log(data);
            }
        } catch (e) {
            console.log(e.message);
        }

        // if everything is done, re-fetch tasks
        const remainExpanders = document.querySelectorAll('div.amplify-expander');
        if (!remainExpanders || remainExpanders.length === 0) {
            await getTasks(aProfile);
        }
    }

    useEffect(() => {
        // if no selected profile but have profiles, pick the first
        if (!Object.keys(aProfile).length && profiles.length > 0) {
            updateAProfile(profiles[0]);
        }
        // if tasks are empty, fetch for the selected profile
        if (Object.keys(aProfile).length && tasks.length === 0) {
            getTasks(aProfile);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [profiles, updateAProfile, aProfile]);

    // Renders tasks by given type
    function tasksByType(inputTasks, type) {
        let filteredTasks = inputTasks.filter(task => task.SK.indexOf(type) > -1);

        return (
            <Collection
                direction='column'
                type='list'
                items={filteredTasks}
                searchNoResultsFound={
                    <Flex justifyContent="center">
                        <Text>
                            Nothing found, please try starting from <b>Grow</b> tab in <Link href='/settings/'>Settings</Link>.
                        </Text>
                    </Flex>
                }
            >
                {(item, index) => (
                    <View key={index} padding="0rem">
                        <Expander
                            className='task-expander'
                            isCollapsible={true}
                            maxWidth="vw"
                            id={"task-" + index}
                        >
                            <ExpanderItem
                                title={
                                    <Flex
                                        wrap="nowrap"
                                        alignItems="center"
                                        justifyContent="flex-start"
                                        width="100%"
                                    >
                                        {item.avatarUrl.length > 0 ? (
                                            <img
                                                src={item.avatarUrl}
                                                style={{ borderRadius: '50%', maxWidth: '50px', paddingTop: '0.5rem', paddingBottom: '0.5rem' }}
                                                alt={item.name}
                                            />
                                        ) : (
                                            <Badge backgroundColor="hsl(200, 100%, 90%)">
                                                <Text style={{ fontSize: '30px' }}>
                                                    {item.url
                                                        ? item.url
                                                            .replace('https://www.', '')
                                                            .replace('https://', '')
                                                            .replace('http://', '')[0]
                                                            .toUpperCase()
                                                        : "P"
                                                    }
                                                </Text>
                                            </Badge>
                                        )}
                                        <Text isTruncated={true} style={{ width: '100%' }}>
                                            {item.SK.includes("TASK CONNECT")
                                                ? (item.stage === "new" ? <>CONNECT<br /><small>{trimString(item.title, 45)}</small></> : <>CONFIRM CONNECT<br /><small>{item.title}</small></>)
                                                : item.SK.includes("TASK POST")
                                                    ? <>POST</>
                                                    : <>{item.needsIntro ? " REPOST +" : ""}{item.needsComment ? " COMMENT +" : ""} LIKE [{item.like}] </>
                                            }
                                        </Text>
                                        {"pods" in item && item.pods.length > 0 ? <Badge>{item.pods}</Badge> : null}
                                        <Flex wrap="nowrap" alignItems="center" justifyContent="flex-end" width="35%">
                                            <Text as="span">
                                                <b>Earn</b>{" "}
                                                {item.requestType.indexOf("PAID-") > -1
                                                    ? <>{item.quantity}0$<br />for 50</>
                                                    : item.requestType === "PAID"
                                                        ? <>5$<br />for 25</>
                                                        : item.quantity
                                                }
                                                <Rating
                                                    value={1}
                                                    maxValue={1}
                                                    fillColor="hsl(51, 100%, 50%)"
                                                />
                                            </Text>
                                        </Flex>
                                    </Flex>
                                }
                                value={'initial-' + index}
                                maxWidth="100%"
                            >
                                <Image src={item.screenshot} style={{ maxWidth: '100%' }} />
                                {(item.SK.indexOf("TASK CONNECT") > -1) && (
                                    <>
                                        <Text as="span">
                                            <b>Followers:</b> {item.followers} &nbsp;
                                        </Text>
                                        {(item.location || item.addressWithCountry) && (
                                            <Text as="span">
                                                <b>Location:</b> {item.location ? item.location : item.addressWithCountry ? item.addressWithCountry : "N/A"} &nbsp;
                                            </Text>)}
                                        <br />
                                        <Text as="span">
                                            <b>Headline:</b> {item.headline} &nbsp;
                                        </Text>
                                        {item.companyCurrentSubtitle && item.companyCurrentLogo && (
                                            <>
                                                <br />
                                                <Text
                                                    as="span"
                                                    style={{ display: 'inline-flex', alignItems: 'center' }}
                                                >
                                                    <b>Company:&nbsp;</b>
                                                    <img
                                                        src={item.companyCurrentLogo}
                                                        alt={item.companyCurrentSubtitle}
                                                        style={{
                                                            width: '40px',
                                                            height: '40px',
                                                            borderRadius: '50%',
                                                            marginRight: '0.5rem'
                                                        }}
                                                    />
                                                    {item.companyCurrentSubtitle}
                                                </Text>
                                            </>
                                        )}
                                        <br />
                                    </>
                                )}
                                <br />
                                {/* Additional logic for different SK conditions */}
                                {item.SK.indexOf("TASK POST") > -1 ? (
                                    <Text as="span">
                                        <b>Step 1.</b> Copy suggested {item.category} news post text and link: <br /><br />
                                        <i><b>{item.title}</b><br /><br /> {item.postText}<br /><br /> {item.url}</i><br /><br />
                                        <Link
                                            onClick={async (e) => {
                                                e.preventDefault();
                                                try {
                                                    await navigator.clipboard.writeText(item.title + '\n\n' + item.postText + '\n\n' + item.url);
                                                } catch (err) {
                                                    console.log('Clipboard copy error', err);
                                                }
                                            }}
                                            id={"copy-" + index}
                                            href='#'
                                            rel="noreferrer"
                                        >
                                            Click TO COPY post text
                                        </Link>
                                    </Text>
                                ) : (
                                    <Text as="span">
                                        <b>Step 1.</b> Open {item.SK.indexOf("TASK CONNECT") > -1 ? 'profile' : 'post'} URL:{" "}
                                        <Link
                                            onClick={() => {
                                                setDoneButtons(doneButtons.map((el, i) => (i === index ? false : el)));
                                            }}
                                            href={isMobile
                                                ? item.postUrl.replace(/https:\/\/(.+?)\.linkedin\.com/, 'linkedin://')
                                                : item.postUrl}
                                            target='_blank'
                                            rel="noreferrer"
                                        >
                                            OPEN
                                        </Link>
                                    </Text>
                                )}
                                <br /><br />

                                {/* If TASK POST -> step 2. Open LinkedIn. Otherwise show Connect/Like instruction */}
                                {item.SK.indexOf("TASK POST") > -1 ? (
                                    <Text as="span">
                                        <b>Step 2.</b> Open LinkedIn and publish the post:{" "}
                                        <Link
                                            onClick={() => {
                                                setDoneButtons(doneButtons.map((el, i) => (i === index ? false : el)));
                                            }}
                                            href={isMobile ? 'linkedin:///feed/' : 'https://www.linkedin.com/feed/'}
                                            target='_blank'
                                            rel="noreferrer"
                                        >
                                            OPEN LinkedIn
                                        </Link>
                                        <br /><br />
                                        <b>Step 3.</b> Provide the post Url:{" "}
                                        <TextField
                                            id={"postUrl-task-" + index}
                                            hasError={postUrlHasError}
                                            errorMessage="please fill in correct LinkedIn post URL"
                                            placeholder="e.g. https://www.linkedin.com/posts/LongString ..."
                                            onChange={() => {
                                                if (!document.getElementById("postUrl-task-" + index).value) {
                                                    setPostUrlHasError(true);
                                                } else {
                                                    setPostUrlHasError(false);
                                                }
                                            }}
                                        />
                                    </Text>
                                ) : (
                                    <Text as="span">
                                        <b>Step 2.</b>{" "}
                                        {item.SK.indexOf("TASK CONNECT") > -1
                                            ? item.stage === 'new'
                                                ? <>Connect by clicking: <b>Connect</b></>
                                                : <> If you see <b>Pending</b>, please click: <b>Pending</b> & then <b>Withdraw</b> in the popup <Button type="submit" onClick={() => setTaskStage(item, "rejected", "task-" + index)} backgroundColor="red" color="white">WITHDRAWN</Button> </>
                                            : <>Deliver LIKE by clicking: Like as [{item.like}]</>
                                        }
                                    </Text>
                                )}

                                {/* Possibly deliver COMMENT or REPOST */}
                                {(item.needsComment && ((item.requestType === "FREE") || (item.requestType === "PAID"))) && (
                                    <Text as="span">
                                        <br /><br />
                                        <b>Step 3.</b> Deliver a COMMENT by typing: <br /><br />
                                        <i>{item.comment}</i><br /><br />
                                        <Link
                                            onClick={async (e) => {
                                                e.preventDefault();
                                                try {
                                                    await navigator.clipboard.writeText(item.comment);
                                                } catch (err) {
                                                    console.log('Clipboard copy error', err);
                                                }
                                            }}
                                            id={"copy-" + index}
                                            href='#'
                                            rel="noreferrer"
                                        >
                                            Click TO COPY comment text
                                        </Link>
                                    </Text>
                                )}

                                {item.requestType.indexOf("REPOST") > -1 && (
                                    <>
                                        <br /><br /><b>Step 3.</b> Deliver COMMENT by typing: <br /><br />
                                        <i>{item.comment}</i><br /><br />
                                        <Link
                                            onClick={async (e) => {
                                                e.preventDefault();
                                                try {
                                                    await navigator.clipboard.writeText(item.comment);
                                                } catch (err) {
                                                    console.log('Clipboard copy error', err);
                                                }
                                            }}
                                            id={"copy-" + index}
                                            href='#'
                                            rel="noreferrer"
                                        >
                                            Click TO COPY comment text
                                        </Link>
                                        <br /><br />
                                        <b>Step 4.</b> Deliver REPOST by clicking "Repost", then "...with your thoughts" & typing: <i>{item.intro}</i>
                                        <br /><br />
                                        <b>Step 5.</b> Provide the repost Url:{" "}
                                        <TextField
                                            id={"repostUrl-task-" + index}
                                            hasError={repostUrlHasError}
                                            errorMessage="please fill in correct LinkedIn repost URL"
                                            placeholder="e.g. https://www.linkedin.com/posts/LongString ..."
                                            onChange={() => {
                                                if (!document.getElementById("repostUrl-task-" + index).value) {
                                                    setRepostUrlHasError(true);
                                                } else {
                                                    setRepostUrlHasError(false);
                                                }
                                            }}
                                        />
                                        <br /><br />
                                        <b>Step 6.</b>
                                    </>
                                )}

                                {/* Next step: confirm either POST, CONNECT, or ENGAGE */}
                                {((item.needsComment && ((item.requestType === "FREE") || (item.requestType === "PAID"))) || (item.SK.indexOf("TASK POST") > -1)) ? (
                                    <>
                                        <br /><br /><Text as="span"><b>Step 4. </b></Text>
                                    </>
                                ) : item.requestType.indexOf("REPOST") > -1 ? null : (
                                    <>
                                        <br /><br /><Text as="span"><b>Step 3. </b></Text>
                                    </>
                                )}
                                Confirm {item.SK.indexOf("TASK POST") > -1
                                    ? 'posting'
                                    : item.SK.indexOf("TASK CONNECT") > -1
                                        ? 'connection'
                                        : 'delivery'} by clicking&nbsp;
                                <Button
                                    disabled={doneButtons[index]}
                                    type="submit"
                                    onClick={() => {
                                        if (item.requestType === "FREE-REPOST") {
                                            const checkVal = document.getElementById("repostUrl-task-" + index)?.value || "";
                                            if (!checkVal) {
                                                setRepostUrlHasError(true);
                                                return;
                                            }
                                            setRepostUrlHasError(false);
                                        }
                                        if (item.SK.indexOf("TASK CONNECT") > -1) {
                                            if (item.stage === 'new') {
                                                setTaskStage(item, "pending", "task-" + index);
                                            } else if (item.stage === 'pending') {
                                                setTaskStage(item, "completed", "task-" + index);
                                            }
                                        } else if (item.SK.indexOf("TASK POST") > -1) {
                                            const checkVal = document.getElementById("postUrl-task-" + index)?.value || "";
                                            if (!checkVal) {
                                                setPostUrlHasError(true);
                                                return;
                                            }
                                            setPostUrlHasError(false);
                                            setTaskStage(item, "attempted", "task-" + index);
                                        } else {
                                            setTaskStage(item, "attempted", "task-" + index);
                                        }
                                        updateBalance(balance + item.quantity);
                                    }}
                                    id={"task-" + index}
                                >
                                    {item.SK.indexOf("TASK CONNECT") > -1
                                        ? (item.stage === 'new' ? 'DONE' : 'CONNECTED')
                                        : 'DONE'
                                    }
                                </Button>
                                <br /><br />
                                {item.SK.indexOf("TASK CONNECT") < 0 || item.stage === 'new' ? (
                                    <Flex wrap="nowrap" alignItems="center" justifyContent="flex-end">
                                        <Button
                                            type="submit"
                                            onClick={() => setTaskStage(item, "rejected", "task-" + index)}
                                            backgroundColor="red"
                                            color="white"
                                        >
                                            SKIP
                                        </Button>
                                    </Flex>
                                ) : null}
                            </ExpanderItem>
                        </Expander>
                    </View>
                )}
            </Collection>
        );
    }

    return (
        <View align="center">
            {Object.keys(aProfile).length > 0 ? (
                <>
                    {aProfile.validated ? (
                        <View maxWidth="1000px" align="left">
                            <View align="center">
                                <h2>Complete all <br />3 circles daily</h2>
                                <TaskDonutCharts
                                    validatedProfile={[aProfile]}
                                    engagePercent={engagePercent}
                                    activeTab={tabMapping[currentTab]}
                                />
                            </View>
                            <br />
                            {isLoading ? (
                                <Loader variation="linear" />
                            ) : (
                                <Tabs
                                    spacing="equal"
                                    currentIndex={currentTab}
                                    onChange={(index) => setCurrentTab(index)}
                                >
                                    <TabItem title={isMobile ? "Engage" : "Engage"}>
                                        <><br />{tasksByType(tasks, "CAMPAIGN")}</>
                                    </TabItem>
                                    <TabItem title={isMobile ? "Post" : "Post"}>
                                        <><br />{tasksByType(tasks, "POST")}</>
                                    </TabItem>
                                    <TabItem title={isMobile ? "Grow" : "Grow"}>
                                        <><br />
                                            <GrowChart aProfile={aProfile} isMobile={isMobile} />
                                            <br />
                                            {tasksByType(tasks, "CONNECT")}</>
                                    </TabItem>
                                </Tabs>
                            )}

                            {(tasks.length === 0 && !isLoading) ? (
                                balance > 54
                                    ? <View textAlign="center"><br /><br />Please check again in few hours.</View>
                                    : <View textAlign="center"><br /><br />
                                        <Button onClick={() => { window.location.reload(); }}>
                                            GET MORE TASKS
                                        </Button>
                                    </View>
                            ) : null}
                        </View>
                    ) : (
                        <AddProfile
                            updateProfiles={updateProfiles}
                            aProfile={aProfile}
                            updateAProfile={updateAProfile}
                        />
                    )}
                </>
            ) : (
                <View maxWidth="1000px" align="left">
                    <Heading level={3} fontWeight={'bold'} textAlign="center">Tasks</Heading>
                    <View align="center">
                        <Text variation="secondary">
                            <br />
                            Start by adding social media profile to start earning from it.
                            <br />
                        </Text>
                        <br />
                        <Button variation="primary" onClick={() => { navigate("/addProfile") }}>
                            ADD PROFILE
                        </Button>
                    </View>
                    <br /><br />
                </View>
            )}
        </View>
    );
}
